import { useState } from 'react';
import useCallApiAndLoad from '../../../hooks/useCallApiAndLoad';
import useAuth from '../../../hooks/useAuth';
import { InvestorProjectDetail } from '../models/investors';
import {
  getInvestorProjectDetailEndpoint,
  updaterProjectEndpoint,
} from '../services/investorService';
import { fetchResponseAdapter } from '../../../adapters/fetchAdapter';

const useProject = () => {
  const { callEndpoint } = useCallApiAndLoad();
  const [apiErrors, setApiErrors] = useState<string | null>(null);

  const { getAuthToken } = useAuth();
  const token = getAuthToken();

  const doProjectInfo = async (projectId: string) => {
    const { data } = await callEndpoint(
      getInvestorProjectDetailEndpoint(projectId, token),
    );
    const response = fetchResponseAdapter(data);

    return response.data;
  };

  const doUpdateProject = async (
    projectId: string,
    payload: Partial<InvestorProjectDetail>,
  ): Promise<number> => {
    const { data, status } = await callEndpoint(
      updaterProjectEndpoint(projectId, payload, token),
    );
    const response = fetchResponseAdapter(data);

    if (status !== 201) setApiErrors(response.message);

    return status;
  };

  return {
    apiErrors,
    doProjectInfo,
    doUpdateProject,
  };
};

export default useProject;
